var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.28,
    height: 17.381,
    viewBox: "0 0 14.28 17.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .doorA {\n                fill: #253e58;\n                stroke: #253e58;\n                stroke-width: 0.5px;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "doorA",
    d: "M21.232,29.881H30.86a1.146,1.146,0,0,0,1.152-1.141V26.916a.23.23,0,0,0-.461,0v1.825a.688.688,0,0,1-.691.684H21.232a.688.688,0,0,1-.691-.684v-14.6a.688.688,0,0,1,.691-.684H30.86a.688.688,0,0,1,.691.684v1.825a.23.23,0,0,0,.461,0V14.141A1.146,1.146,0,0,0,30.86,13H21.232a1.146,1.146,0,0,0-1.152,1.141v14.6A1.146,1.146,0,0,0,21.232,29.881Z",
    transform: "translate(-20.08 -13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "doorA",
    d: "M44.118,33.008a.232.232,0,0,0-.313.014.227.227,0,0,0-.01.31l3.361,3.283H38.61a.228.228,0,1,0,0,.456h8.545l-3.363,3.283a.227.227,0,0,0-.076.226.229.229,0,0,0,.169.17.232.232,0,0,0,.229-.072L47.877,37a.227.227,0,0,0,0-.324Z",
    transform: "translate(-34.165 -28.402)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/door-icon.e8b27615.svg";
export { ForwardRef as ReactComponent };